
import Vue from "vue";
import { NewAlertsApiFunc, setAccessToken } from "@/api";
import { Alert } from "@/models";

import AlertList from "./components/AlertList.vue";
import Pager from "@/components/BasePager.vue";
import TheTemplate from "../TheTemplate.vue";

export type FilterCondition = {
  alertType?: string;
  toiletType?: string;
};

export type DataType = {
  alerts: Array<Alert>;
  filterCondition: FilterCondition;
  totalPage: number;
  currentPage: number;
};

export default Vue.extend({
  name: "AlertListScreen",

  data(): DataType {
    return {
      alerts: [],
      filterCondition: {
        alertType: "",
        toiletType: "",
      },
      totalPage: 0,
      currentPage: 0,
    };
  },

  mounted() {
    this.fetchAlerts();
  },

  components: {
    TheTemplate,
    AlertList,
    Pager,
  },

  methods: {
    async fetchAlerts(page?: number): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      const filterString: string = JSON.stringify({
        alertType: this.filterCondition.alertType,
        toiletType: this.filterCondition.toiletType,
      });
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewAlertsApiFunc().listAlerts(
        companyId,
        filterString,
        page
      );
      if (err != null) {
        this.$handleApiError(err, () => {
          this.fetchAlerts(page);
        });
        return;
      }

      this.alerts = data.list;
      this.currentPage = data.currentPage;
      this.totalPage = data.totalPage;
    },

    updateFilterCondition(condition?: FilterCondition): void {
      this.filterCondition = Object.assign(this.filterCondition, condition);
    },

    changePage(page: number): void {
      this.fetchAlerts(page);
    },
  },
});
